import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const MaleSVG: React.FC<Props> = ({
  color,
}) => {
  return (
    <svg width="14" height="14" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.4893 0.864258C20.0473 0.864258 20.5 1.31197 20.5 1.86426V6.35742C20.5 6.90971 20.0473 7.35742 19.4893 7.35742C18.9314 7.35723 18.4795 6.90959 18.4795 6.35742V4.27734L14.8604 7.8584C17.4238 10.9963 17.2327 15.6063 14.2852 18.5234C11.1315 21.6433 6.01905 21.6439 2.86524 18.5244C2.11433 17.783 1.51919 16.9014 1.11329 15.9316C0.707582 14.9623 0.498877 14.057 0.500006 13.0078C0.498719 11.9584 0.706529 10.785 1.11231 9.81543C1.5182 8.84569 2.11429 7.96496 2.86524 7.22363C5.7402 4.37988 10.2417 4.12958 13.4043 6.4707L17.0488 2.86426H14.9492C14.3913 2.86417 13.9385 2.41649 13.9385 1.86426C13.9385 1.31203 14.3913 0.864349 14.9492 0.864258H19.4893ZM12.6953 8.4834C10.32 6.29844 6.60437 6.34912 4.292 8.63672H4.29102C3.72812 9.1923 3.28176 9.85325 2.97755 10.5801C2.67349 11.3067 2.51751 12.0856 2.51856 12.8721V12.875C2.51756 13.6617 2.6743 14.4411 2.97852 15.168C3.28268 15.8946 3.7284 16.5548 4.29102 17.1104L4.292 17.1113C6.65739 19.4514 10.492 19.4513 12.8574 17.1113C15.2223 14.7708 15.2224 10.9762 12.8574 8.63574C12.8515 8.62991 12.8448 8.62494 12.8389 8.61914C12.8066 8.59417 12.7748 8.56748 12.7451 8.53809C12.7274 8.52058 12.7114 8.50183 12.6953 8.4834Z" fill={`${color}`} />
    </svg>
  );
};

MaleSVG.defaultProps = {
  color: getComputedCSSVariable('label-gray'),
};

export default MaleSVG;
